// #region: Class definition *********************************************************************/
/**
 * Global broadcast messages @see {eventBroadcaster}.
 */
window.broadcasts = class {

    // #region: Static Data **********************************************************************/
    // Custom events.
    static ADD_VALIDATORS = "addValidators";
    static APPLICATION_READY = "applicationReady";
    static LOCK_SCREEN = "lockScreen";
    static PAGE_CHANGED = "pageChanged";
    static PAGE_WILL_CHANGE = "pageWillChange";
    static RIGHTS_LOADED = "rightsLoaded";

    // Plugin events.
    static FORM_SAVED_DATA_LOADED = "formSavedDataLoaded";
    // #endregion ********************************************************************************/

    // #region: Build ****************************************************************************/
    /**
     * Identifies class.
     * @returns {String}                        The string representation of this class.
     */
    toString() {
        return "[broadcasts]";
    }

    static toString() {
        return "[broadcasts]";
    }

    /** 
     * Identifies the version.
     * @returns {String}                        The version number of this class.
     */
    static version() {
        return "1.0.0";
    }
    // #endregion ********************************************************************************/

};
// #endregion ************************************************************************************/
